import script from "./NewsMess.vue?vue&type=script&setup=true&name=NewsMess&lang=js"
export * from "./NewsMess.vue?vue&type=script&setup=true&name=NewsMess&lang=js"

import "./NewsMess.vue?vue&type=style&index=0&id=5b7154ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b7154ac"]])

export default __exports__